import { render, staticRenderFns } from "./SuccessStoriesReorder.vue?vue&type=template&id=13edc21d&scoped=true&"
import script from "./SuccessStoriesReorder.vue?vue&type=script&lang=js&"
export * from "./SuccessStoriesReorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13edc21d",
  null
  
)

export default component.exports